
import { FormHelperText, TextField, useFormControl } from "@mui/material";
import { useMemo, useState } from "react";
import * as Yup from "yup";
import { requiredText } from "../../../../utils/helpers";
import { isValidPhoneNumber } from "react-phone-number-input";

export const FormSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(70, 'Too Long!')
    .required(requiredText('Name')),
  email: Yup.string()
    .email('Please enter a valid email ID')
    .required(requiredText('Email')),
  phone: Yup.string()
    .test({
      nam: 'phone',
      message: 'Please enter a valid phone number',
      test: (value) => {
        return value ? isValidPhoneNumber(value, { defaultCountry: 'IN' }) : true
      }
    }),
  org: Yup.string(),
  interest: Yup.string()
    .required(requiredText('Interest')),
  message: Yup.string()
});

export const TextInput = (props) => {

  return <TextField color="secondary" {...props}
    variant="standard"
    size="small"
    sx={{
      '& .MuiFormHelperText-root': {
        margin: 0
      },
      '& .MuiFormLabel-root[data-shrink="true"]': {
        color: 'var(--bg-blue)'
      },
      '& .MuiInputBase-root::after': {
        borderColor: 'var(--bg-blue)'
      },
    }}
  />

}

export const FormHelperTextWrapper = ({ formik, name }) => {
  const { focused, ...rest } = useFormControl() || {};

  const [color, setColor] = useState('inherit')

  const helperText = useMemo(() => {

    if (formik.errors[name]) {
      setColor('var(--form-error)')
      return formik.errors[name];
    }

    return '';
  }, [formik]);

  return <FormHelperText
    sx={{
      marginTop: 0,
      marginLeft: 0,
      color
    }}
  >{helperText}</FormHelperText>;
}